import React from "react";
import { FaGithub, FaLinkedin, FaStackOverflow, FaGlobe } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { usePortfolioData } from '../context/PortfolioDataContext';
import SectionWithNeuralBg from './SectionWithNeuralBg';

const iconMap = {
  'GitHub': FaGithub,
  'LinkedIn': FaLinkedin,
  'Twitter': FaXTwitter,
  'Stack Overflow': FaStackOverflow,
  'StackOverflow': FaStackOverflow,
  'Website': FaGlobe,
};

export default function Footer() {
  const { data } = usePortfolioData();
  const personalInfo = data.personalInfo;
  const currentYear = new Date().getFullYear();

  return (
    <SectionWithNeuralBg as="footer" className="border-t border-gray-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Social Icons - Centered */}
        <div className="flex justify-center gap-6 mb-6">
          {personalInfo.socialLinks && personalInfo.socialLinks.map((link) => {
            const Icon = iconMap[link.platform] || FaGlobe;
            return (
              <a
                key={link.platform}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors"
                aria-label={link.platform}>
                <Icon className="w-6 h-6" />
              </a>
            );
          })}
        </div>

        {/* Copyright - Centered */}
        <p className="text-center text-gray-400 text-sm">
          © {currentYear} {personalInfo.name}. All rights reserved.
        </p>
      </div>
    </SectionWithNeuralBg>
  );
}
